module.exports = __webpack_public_path__ + "assets/img/301.2daaa594.png";